<script>
import axios from "axios";

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
let user = JSON.parse(localStorage.getItem("user"));

/**
 * Register component
 */
export default {
  page: {
    title: "Sửa dịch vụ mua hộ lưu kho",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      items: [
        {
          text: "Trang Chủ",
          href: "/",
        },
        {
          text: "Dịch vụ",
          href: "/danh-sach-dich-vu",
        },
        {
          text: "Sửa dịch vụ mua hộ lưu kho",
          active: true,
        },
      ],

      service: {
        name: "Sửa dịch vụ mua hộ lưu kho",
        type: 1,
        buystore: {
          price_store: 10,
          price_buy: 10,
          disc_store: 0,
          disc_buy: 0,
          disc_unit: "%",
        },
      },
      submitted: false,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    // Try to register the service in with the email, name
    // and password they provided.

    tryToUpdateIn() {
      this.submitted = true;

      // stop here if form is invalid
      axios({
        url: process.env.VUE_APP_SERVER_URL + "/service/update",
        method: "post",
        headers: {
          authorization: user.token,
        },

        data: this.service,
      })
        .then(({ data }) => {
          this.$toasted.success("Sửa dịch vụ thành công");
        })
        .catch((error) => {
          this.$toasted.error("Sửa dịch vụ có lỗi");
        });
    },
  },

  created() {
    if (!this.$route.query.id) {
      this.$router.push("/");
    }
    let _id = this.$route.query.id;

    axios({
      url: process.env.VUE_APP_SERVER_URL + "/service/info",
      method: "post",
      headers: {
        authorization: user.token,
      },

      data: {
        _id: _id,
      },
    })
      .then(({ data }) => {
        if (data) {
          console.log(data);
          this.service = data;
        } else {
          this.$toasted.error("Không tìm thấy dịch vụ phù hợp");
          this.$router.push("/");
        }
      })
      .catch((err) => {
        console.log(err);
        this.$toasted.error("Không tìm thấy dịch vụ phù hợp");
        // this.$router.push("/");
      });
  },
};
</script>
<style>
.b-form-tag-content {
  border: 1px solid #e5e5e5;
  background: #f8f9fa;
  color: #000;
  border-radius: 2px;
  padding: 5px;
  text-transform: capitalize;
}

.b-form-tag-remove {
  border: 0px;
  margin-left: 2px;
}
</style>
<template>
  <Layout>
    <PageHeader :items="items" />
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="card overflow-hidden">
          <div class="card-body pt-0">
            <b-form class="my-2 p-2" @submit.prevent="tryToUpdateIn">
              <b-form-group
                class="mb-3"
                id="service-name"
                label="Tên dịch vụ"
                label-for="name"
              >
                <b-form-input
                  v-model="service.name"
                  type="text"
                  debounce="1000"
                  placeholder="Gửi hàng US-VN"
                  aria-required=""
                ></b-form-input>
              </b-form-group>
              <div class="px-3">
                <b-row>
                  <b-col class="md-3">
                    <b-form-group
                      class="mb-3"
                      label="% mua hộ"
                      label-for="service-money-name"
                    >
                      <b-form-input
                        v-model="service.buystore.price_buy"
                        debounce="1000"
                        type="number"
                        step="0.01"
                        min="0.00"
                        max="1000000.00"
                        :placeholder="'Nhập giá '"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col class="md-3">
                    <b-form-group class="mb-3" label="Giảm giá">
                      <b-form-input
                        v-model="service.buystore.disc_buy"
                        debounce="1000"
                        type="number"
                        step="0.01"
                        min="0.00"
                        max="1000000.00"
                        :placeholder="'Nhập giảm giá mua hộ của '"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <span>% nhân viên</span>
                      <div class="py-2">
                        <b-form-input
                          v-model="service.buystore.salary_buy"
                          debounce="500"
                          type="number"
                          step="0.01"
                          min="0.00"
                          max="1000000.00"
                          placeholder="Nhập dữ liệu"
                        ></b-form-input>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <span>Đơn vị giảm giá </span>
                      <div class="py-2">
                        <b-form-select
                          class="px-2 form-control"
                          v-model="service.buystore.disc_unit"
                          size="md"
                          :options="['$', '%']"
                        ></b-form-select>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="mt-4 d-grid">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Sửa dịch vụ</b-button
                >
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>